var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.isReady
    ? _c(
        "div",
        {
          staticClass: "page-body content-inner typography",
          attrs: { "data-content-width": "wide" },
        },
        [
          _c(
            "div",
            { staticClass: "page-header with-breadcrumbs" },
            [
              _c("h1", [_vm._v(_vm._s(_vm.t("app-inquiry-details")))]),
              _vm._v(" "),
              _c("breadcrumbs", { attrs: { trail: _vm.trail } }),
            ],
            1
          ),
          _vm._v(" "),
          _c("h2", [
            _vm._v(
              _vm._s(_vm.inquiry.attributes.firstName) +
                " " +
                _vm._s(_vm.inquiry.attributes.lastName)
            ),
          ]),
          _vm._v(" "),
          _c("h3", [_vm._v(_vm._s(_vm.inquiry.attributes.role))]),
          _vm._v(" "),
          _c("table", { staticClass: "ui-table fixed" }, [
            _c("tr", [
              _c("td", { staticClass: "heading" }, [
                _vm._v(_vm._s(_vm.t("app-program"))),
              ]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.inquiry.attributes.programTitle))]),
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "heading" }, [
                _vm._v(_vm._s(_vm.t("app-inquiry-date"))),
              ]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.inquiry.attributes.createdDisplay))]),
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "heading" }, [
                _vm._v(_vm._s(_vm.t("app-status"))),
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  _vm._s(
                    _vm.inquiry.attributes.status == "app-contacted"
                      ? _vm.t("app-contacted")
                      : _vm.t("app-un-contacted")
                  )
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "heading" }, [
                _vm._v(_vm._s(_vm.t("app-relay-email"))),
              ]),
              _vm._v(" "),
              _c("td", [
                _c(
                  "a",
                  {
                    attrs: {
                      href: `mailto:${_vm.inquiry.attributes.relayEmail}`,
                    },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.inquiry.attributes.relayEmail) +
                        "\n        "
                    ),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "heading" }, [
                _c("label", [_vm._v(_vm._s(_vm.t("app-email")))]),
              ]),
              _vm._v(" "),
              _c("td", [
                _vm.inquiry.attributes.status == "app-contacted"
                  ? _c("div", [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: `mailto:${_vm.inquiry.attributes.email}`,
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.inquiry.attributes.email) +
                              "\n          "
                          ),
                        ]
                      ),
                    ])
                  : _c("div", { staticClass: "hidden" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.t("app-hidden")) +
                          "\n        "
                      ),
                    ]),
              ]),
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "heading" }, [
                _vm._v(_vm._s(_vm.t("app-contact-phone"))),
              ]),
              _vm._v(" "),
              _c("td", [
                _vm.inquiry.attributes.status == "app-contacted"
                  ? _c("div", [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.inquiry.attributes.phone) +
                          "\n        "
                      ),
                    ])
                  : _c("div", { staticClass: "hidden" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.t("app-hidden")) +
                          "\n        "
                      ),
                    ]),
              ]),
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "heading" }, [
                _vm._v(_vm._s(_vm.t("app-voice"))),
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  _vm._s(
                    _vm.inquiry.attributes.call == 1 ? _vm.t("app-yes") : ""
                  )
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "heading" }, [
                _vm._v(_vm._s(_vm.t("app-sms"))),
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  _vm._s(
                    _vm.inquiry.attributes.sms == 1 ? _vm.t("app-yes") : ""
                  )
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "heading" }, [
                _vm._v(_vm._s(_vm.t("app-how-did-you-hear-about-us"))),
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  _vm._s(_vm.t(_vm.inquiry.attributes.howDidYouHearAboutUs))
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "heading" }, [
                _vm._v(_vm._s(_vm.t("app-how-did-you-hear-about-us-other"))),
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  _vm._s(_vm.inquiry.attributes.howDidYouHearAboutUsOther)
                ),
              ]),
            ]),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }